import { render, staticRenderFns } from "./Configurador.vue?vue&type=template&id=2480e5e9"
import script from "./Configurador.vue?vue&type=script&lang=js"
export * from "./Configurador.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports